export const PANEL_ID = 'mainNav';

export const getToggleMainNavClick = (openPanel, isOpen, closePanel) => () => {
  if (isOpen) {
    closePanel();
  } else {
    openPanel(PANEL_ID);
  }
};
